import { render, staticRenderFns } from "./Favorite.vue?vue&type=template&id=8743283a&"
import script from "./Favorite.vue?vue&type=script&lang=js&"
export * from "./Favorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports